export type IHomeHealthController = ReturnType<
  typeof HomeHealthControllerFactory
>;

export const HomeHealthControllerFactory = ({
  homeHealthService,
}: {
  homeHealthService: IHomeHealthService;
}) => {
  const getSinglePatientInfo: IGetSinglePatientInfoApp = async ({
    patient_id,
  }) => {
    const response = await homeHealthService.getSinglePatientInfo({
      patient_id,
    });
    if (response.success) {
      return {
        success: true,
        data: response.data,
      };
    } else {
      return {
        success: false,
        error: response.error,
      };
    }
  };

  const getPatientGraphData = async ({
    patient_id,
  }: {
    patient_id: number | string;
  }) => {
    const response = await homeHealthService.getPatientGraphData({
      patient_id,
    });
    return response;
  };

  const getSelectedFacilityPatientList = async ({
    clinic_id,
  }: {
    clinic_id: number;
  }) => {
    const response = await homeHealthService.getSelectedFacilityPatientList({
      clinic_id,
    });
    return response;
  };

  return {
    getSinglePatientInfo,
    getPatientGraphData,
    getSelectedFacilityPatientList,
  };
};
